/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Attemptdeleted1Inputs */

const zh_learn_attemptdeleted1 = /** @type {(inputs: Learn_Attemptdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作答记录已删除`)
};

const en_learn_attemptdeleted1 = /** @type {(inputs: Learn_Attemptdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attempt deleted`)
};

const es_learn_attemptdeleted1 = /** @type {(inputs: Learn_Attemptdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intento eliminado`)
};

/**
* | output |
* | --- |
* | "Attempt deleted" |
*
* @param {Learn_Attemptdeleted1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_attemptdeleted1 = /** @type {((inputs?: Learn_Attemptdeleted1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Attemptdeleted1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_attemptdeleted1(inputs)
	if (locale === "en") return en_learn_attemptdeleted1(inputs)
	return es_learn_attemptdeleted1(inputs)
});
export { learn_attemptdeleted1 as "learn_attemptDeleted" }